import { take, catchError, map, switchMap, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import {
  LOAD_SALES_AREA,
  LoadJobsiteSalesArea,
  LoadJobsiteSalesAreaComplete,
  LoadJobsiteSalesAreaFail,
} from '../../../actions/jobsite-actions/jobsite.actions';
import { getSelectedBusinessLine, OrderBuilderState } from '../../../../../reducers';
import { IJobsiteSalesAreasResponse } from '@cemex-core/cmx-api/models/jobsite-sales-areas/jobsite-sales-areas-response';
import { prepareSalesAreaRequestParams } from '../../../helpers/location.helper';
import { JobsiteSalesAreasService } from '@cemex-core/cmx-api';
import { ProductType } from '@cemex-core/cmx-api/models/business-lines/product-type';

@Injectable()
export class JobsiteLoadSalesAreaEffects implements IEffect {
  JobsiteLoadSalesArea$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_SALES_AREA),
      filter((action: LoadJobsiteSalesArea) => !!action.payload),
      switchMap((payload: LoadJobsiteSalesArea) => {
        return this.store.select(getSelectedBusinessLine).pipe(
          take(1),
          map((selectedBusinessLine: ProductType) => selectedBusinessLine.productTypeId),
          switchMap((businessLineId: number) => {
            return this.jobsiteSalesAreaService
              .getAddresses(prepareSalesAreaRequestParams(payload.payload, businessLineId))
              .pipe(
                map((response: IJobsiteSalesAreasResponse) => {
                  return new LoadJobsiteSalesAreaComplete(response.jobsiteSalesAreas);
                }),
                catchError((error) => of(new LoadJobsiteSalesAreaFail(error))),
              );
          }),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private jobsiteSalesAreaService: JobsiteSalesAreasService,
    private store: Store<OrderBuilderState>,
  ) {}
}
